<template>
  <div class="by_site">
    <div
      class="bank__block"
      v-for="(row, index) in sortedBankInfo"
      :key="index"
    >
      <div class="flexs bank__info__block">
        <img
          :src="row[0].bank.logo"
          :alt="`Bank ${row[0].bank.name} logo`"
          style="justify-self: center"
        />
        <p>
          <span>{{ row[0].bank.name }}</span
          ><br />
          <span v-if="row && row[0].bank.license"
            >№ {{ row[0].bank.license }}</span
          >
        </p>
      </div>
      <div class="sites">
        <div
          class="site"
          v-for="(item, id) in row"
          :key="`index_${index}_id_${id}`"
        >
          <div>
            <div class="captions">
              <span v-if="item.websites">
                на
                <a
                  :href="`/rating/userbank?bank_id=${item.bank_id}&product_id=${item.product_id}`"
                  target="_blank"
                  rel="referer"
                  class="onHoverDecorate"
                  >{{ item.websites.name }}</a
                >
              </span>
            </div>

            <div
              v-if="item.rate.rate.length == 0"
              class="flex flex-align-center"
            >
              Нет оценок по данному банку и площадке
            </div>
            <div v-else class="rate__and__caption">
              <v-rating
                v-model="item.rate.avaregeRate"
                color="yellow darken-3"
                background-color="grey darken-1"
                empty-icon="$ratingFull"
                half-increments
                hover
                class="rating_star noHover rating__off"
                rating__off
                disabled
              />
              <span>{{ item.rate.avaregeRate.toFixed(1) }}</span>
              <span>(оценок {{ item.rate.count }})</span>
              <!-- <ReteBlock
              :rate="calcBankRate(item.rate.rate)"
              :title="``"
              :avarageCount="item.rate.count"
              :avarege="item.rate.avaregeRate"
              :makeRate="false"
              :showOnlyAvarege="true"
            /> -->
            </div>
            <div
              v-if="!item.rateInfo.userInfo.goodOrBad.length"
              class="flex flex-align-center"
            >
              <a
                :href="`/rating/userbank?bank_id=${item.bank_id}&product_id=${item.product_id}&dop=true`"
                target="_blank"
                rel="referer"
                class="onHoverDecorate"
                ><v-icon class="onHover" right small style="margin: 0"
                  >comment</v-icon
                >
                Оценить и прокомментировать</a
              >
            </div>
            <div v-if="item.rateInfo.userInfo.goodOrBad.length">
              <a
                :href="`/rating/userbank?bank_id=${item.bank_id}&product_id=${item.product_id}&dop=true`"
                target="_blank"
                rel="referer"
                class="onHoverDecorate"
              >
                <v-icon
                  class="onHover"
                  color="orange"
                  right
                  small
                  style="margin: 0"
                  >comment</v-icon
                >
                Изменить оценку и комментарий
              </a>
            </div>
          </div>
          <div class="goodOrBad">
            <BankProggres :item="item.bank_goodOrBad" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import ReteBlock from "../rateBlock";
import BankProggres from "./BankProggres.vue";
export default {
  name: "by_bank",
  components: {
    // ReteBlock,
    BankProggres,
  },
  data: () => ({}),
  props: {
    bankInfo: { type: Array, default: () => [] },
    search: { type: String, default: "" },
    sort: { type: Number, default: 0 },
  },
  methods: {
    groupByBank(SortBankList) {
      const list = this.DeepCopy(SortBankList);
      let bankList = new Array();
      for (let item of list) {
        bankList.push(item.bank_id);
      }
      bankList = Array.from(new Set(bankList));
      const length = [];
      const banks = new Array();
      for (let item of bankList) {
        const row = list.filter((row) => row.bank_id == item);
        length.push(row.length);
        banks.push(row);
      }
      this.$emit(
        "sortedBankInfoLength",
        length.length ? length.reduce((a, b) => a + b) : 0
      );
      return banks;
    },
  },
  computed: {
    sortedBankInfo() {
      if (this.bankInfo) {
        const sorted = this.DeepCopy(this.groupByBank(this.sortBank));
        return sorted;
      } else {
        this.$emit("sortedBankInfoLength", 0);
        return [];
      }
    },
    searchText() {
      const bank = this.DeepCopy(this.bankInfo);
      const regSearch = new RegExp(this.search, "i");
      return bank.filter((item) => {
        //по каким полям поиск
        if (regSearch.test(item.bank.name)) {
          return true;
        } else if (regSearch.test(String(item.bank.license))) {
          return true;
        } else if (regSearch.test(item.bank.inn)) {
          return true;
        } else if (regSearch.test(item.websites.name)) {
          return true;
        } else {
          return false;
        }
      });
    },
    sortBank() {
      // 0 Рейтинг - сначала максимальный
      // 3 Рейтинг - сначала минимальный
      // 4 Без рейтинга
      // 1 Мои оценки - сначала максимальные
      // 2 Мои оценки - сначала минимальные
      // 5 Без моих оценок
      if (this.sort == 0) {
        //sort by useful
        // return this.searchText();
        return Array.from(this.DeepCopy(this.searchText))
          .sort((a, b) => {
            if (a.rate.avaregeRate > b.rate.avaregeRate) {
              return -1;
            }
            if (a.rate.avaregeRate < b.rate.avaregeRate) {
              return 1;
            }
            // a должно быть равным b
            return 0;
          })
          .filter((item) => (item.rate.avaregeRate > 0 ? true : false));
      } else if (this.sort == 1) {
        //sort by comment date newer
        const banks = this.DeepCopy(this.searchText);
        return Array.from(
          banks.filter((item) => item.rateInfo.userInfo.rate !== false)
        ).sort((a, b) => {
          // CalculateAvaregeRate

          if (a.rate.avaregeRate > b.rate.avaregeRate) {
            return -1;
          }
          if (a.rate.avaregeRate < b.rate.avaregeRate) {
            return 1;
          }
          // a должно быть равным b
          return 0;
        });
      } else if (this.sort == 2) {
        //sort by comment date newer
        return Array.from(this.DeepCopy(this.searchText))
          .filter((item) => item.rateInfo.userInfo.rate !== false)
          .sort((a, b) => {
            // CalculateAvaregeRate
            if (a.rate.avaregeRate > b.rate.avaregeRate) {
              return 1;
            }
            if (a.rate.avaregeRate < b.rate.avaregeRate) {
              return -1;
            }
            // a должно быть равным b
            return 0;
          });
      } else if (this.sort == 3) {
        //sort by useful
        // const nulable = Array.from(this.DeepCopy(this.searchText)).filter(
        //   (item) => item.rate.rate.length == 0
        // );
        // const NotNulable = Array.from(this.DeepCopy(this.searchText)).filter(
        //   (item) => item.rate.rate.length != 0
        // );
        // const sort = Array.from(NotNulable).sort((a, b) => {
        //   if (a.rate.avaregeRate > b.rate.avaregeRate) {
        //     return 1;
        //   }
        //   if (a.rate.avaregeRate < b.rate.avaregeRate) {
        //     return -1;
        //   }
        //   // a должно быть равным b
        //   return 0;
        // });
        // // return [...sort, ...nulable];
        // return [...sort];
        return Array.from(this.DeepCopy(this.searchText))
          .sort((a, b) => {
            if (a.rate.avaregeRate > b.rate.avaregeRate) {
              return 1;
            }
            if (a.rate.avaregeRate < b.rate.avaregeRate) {
              return -1;
            }
            // a должно быть равным b
            return 0;
          })
          .filter((item) => (item.rate.avaregeRate > 0 ? true : false));
      } else if (this.sort == 4) {
        return Array.from(this.DeepCopy(this.searchText)).filter(
          (item) => item.rate.avaregeRate == 0
        );
      } else if (this.sort == 5) {
        return Array.from(this.DeepCopy(this.searchText)).filter(
          (item) => item.rateInfo.userInfo.rate === false
        );
      } else {

        return this.DeepCopy(this.searchText).sort((a,b)=>b.rate.avaregeRate - a.rate.avaregeRate);
      }
    },
  },
};
</script>
<style lang="sass" scoped>
.flexs
  display: flex
  column-gap: 20px
.flex-center
  justify-content: center
.flex-align-center
  align-items: center
.bank__block
  border-bottom: 1px solid #ccc
  display: grid
  grid-template-columns: 1fr 2fr
.bank__info__block
  padding: 10px
  grid-gap: 0px
  img
    width: 80px
    height: 80px
  p
    width: 290px
    padding: 15px 10px
    align-items: center

    font-size: 14px
.site
  padding: 10px 0
  display: grid
  column-gap: 20px
  grid-template-columns: repeat(2,1fr)
.captions
  display: grid
.rate__and__caption
  display: flex
  column-gap: 10px
  align-items: center
  div
    display: inline-block
</style>
